import { PushPinSlash } from '@phosphor-icons/react';

export default PushPinSlash;
